import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PpeService } from 'src/app/services/ppe.service';
import { concatMap, tap } from 'rxjs/operators';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { forkJoin } from 'rxjs';
import { VendorService } from 'src/app/services/vendor.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { GlobalStateService } from 'src/app/services/global-state.service';
import { ExpenseDocTempDetailResponse } from 'src/app/models/expense.model';

@Component({
  selector: 'app-ppe-submit',
  templateUrl: './ppe-submit.component.html',
  styleUrls: ['./ppe-submit.component.scss']
})
export class PpeSubmitComponent {
  warehouses = [];
  filteredWarehouses = [];
  inputs = {};
  timeout = null;
  detailing: { [key: string]: boolean } = {};
  ppeitems = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  depreciations: any[] = [];
  user = null;
  company = null;
  filterWarehouse = new InputAutocompleteModel("", false, false, "", "", "", "", null, []);
  warehouseSelected = null;
  filterWarehouses = [];
  allWarehouses: WarehouseResponse[] = [];
  allowedWarehouses: { [key: number]: boolean } = {};
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");

  document = {
    id: 0,
    date: '',
    month: '',
    typeId: null,
    expenseType: 'Producto',
    series: '',
    number: '',
    total: 0,
    declaredTotal: 0,
    description: ''
  };

  documentTypes = [];
  editDocument = false;

  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  tempDetails: ExpenseDocTempDetailResponse[] = []
  clientSelected = null;

  newRegister = {
    code: '',
    name: '',
    cost: 0,
    percentage: 0,
    depreciation: '',
    asignedName: '',
    asignedDPI: 0,
    localizationName: '',
    quantity: 0
  }

  newRegisterFilterWarehouse = new InputAutocompleteModel('', false, false, '', '', '', '', null, []);
  newRegisterWarehouses: WarehouseResponse[] = [];
  newRegisterWarehouseSelected: WarehouseResponse = null;

  newRegisterCategoryId: number = null;
  newRegisterDepreciationId: number = null;
  newRegisterPercentage: number = 0;

  autoGenerated = false;
  totalCumulative = 0;
  isTranslate: boolean = false;
  showDetails: boolean = true;

  constructor(
    private toastService: ToastrService,
    private ppeService: PpeService,
    private expenseService: ExpenseService,
    private warehouseService: WarehouseService,
    private authService: AuthenticationService,
    private globalState: GlobalStateService,
    private vendorService: VendorService
  ) {
    this.user = authService.getUser();
    this.company = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit(): void {
    this.isTranslate = this.globalState.getIsTranslate();
    this.getInitData();
  }

  getInitData(){
    this.getDepreciations();
  }

  getDepreciations(){
    this.ppeService.getDepreciations().pipe(
      concatMap((response: ResponseObject) => {
        this.depreciations = response.data;
        return this.ppeService.getTemporalItems();
      })
    ).subscribe({
      next: (response: ResponseObject) => {
        this.ppeitems = response.data;
        this.pagination.total = this.ppeitems;
        this.pagination.filter = response.data.map(ppeitem => {
          const category = this.depreciations.find(cat =>
            cat.depreciations.some(dep => dep.id === ppeitem.depreciation)
          );
          return {
            ...ppeitem,
            selectedCategoryId: category ? category.id : null,
            filterWarehouse: new InputAutocompleteModel(ppeitem.localizationName || '', false, false, '', '', '', '', null, []),
            warehouses: [], // resultados individuales por fila
            warehouseSelected: null
          };
        }); 
        this.getDocumentTypes();
        this.validateAutoGenerated(this.ppeitems);
        this.getTotalCost();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getTotalCost() {
    this.totalCumulative = this.ppeitems.reduce((total, item) => {
      const itemCost = (item.cost || 0) * (item.quantity || 0);
      return total + itemCost;
    }, 0);
  }

  getDocumentTypes(){
    this.expenseService.getDocumentTypes().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.documentTypes = clientsData;
        this.getInitVendors();
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  getInitVendors(){
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
        this.getPPETempDoc();
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    }); 
  }


  getPPETempDoc(){
    this.expenseService.getTempPPE().subscribe({
      next: (response: ResponseObject) => {
        if(response.data && response.data.length > 0){
          const temp = response.data[0];

          // Buscar el proveedor en la lista de clients
          const clientFromList = this.clients.find(c => c.id == temp.vendor?.toString());

          if (clientFromList) {
            this.selectClient(clientFromList, 1);
          }else{
            // Error no encuentra el proveedor que seleccione otro 
          }
  
          // Asignar documento
          this.document = {
            id: temp.id || 0,
            date: this.convertTimestampToDate(temp.docDate),
            month: this.convertTimestampToMonth(temp.inputDate),
            typeId: temp.type || null,
            expenseType: 'Producto',
            series: temp.sDoc || '',
            number: temp.noDoc || '',
            total: temp.tdoc || 0,
            declaredTotal: temp.tdec || 0,
            description: temp.desc || ''
          };

          // MOSTRAR DETALLES DE LOS EXPENSE POR MEDIO DEL ENDPOINT(companyId, numero y serie)
          
          response.data.forEach(element => {
            this.getTempDetils(element.id);
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }
  
  getTempDetils(expendeTempId: number) {
    this.expenseService.getDetailsDocumentTemp(expendeTempId).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        if (response.data.listDetails.length > 0)
          this.tempDetails = [...response.data.listDetails]
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Erro al obtener los detalles", "Error");
      }
    });
  }

  validateAutoGenerated(ppeitems){
    if(ppeitems.autoGenerated != null){

    }else{
      // console.log(this.depreciations);
    }
  }

  selectWarehouse(warehouse: WarehouseResponse, target: any) {
    if (target === 'newRegister') {
      this.newRegisterFilterWarehouse.value = warehouse.name;
      this.newRegisterFilterWarehouse.verified = true;
      this.newRegisterFilterWarehouse.data = warehouse;
      this.newRegisterFilterWarehouse.class = 'fa-circle-check';
      this.newRegisterWarehouseSelected = warehouse;
      this.newRegister.localizationName = warehouse.name;
    } else {
      target.filterWarehouse.value = warehouse.name;
      target.filterWarehouse.verified = true;
      target.filterWarehouse.data = warehouse;
      target.filterWarehouse.class = 'fa-circle-check';
      target.warehouseSelected = warehouse;
      target.localizationName = warehouse.name;
    }
  }  
  
  searchWarehouse(target: any) {
    clearTimeout(this.timeout);
    if (target === 'newRegister') {
      this.newRegisterFilterWarehouse.class = 'typing';
    } else {
      target.filterWarehouse.class = 'typing';
    }
  
    this.timeout = setTimeout(() => {
      if (target === 'newRegister') {
        this.getWarehousesByFilter('newRegister');
      } else {
        this.getWarehousesByFilter(target);
      }
    }, 300);
  }
  
  getWarehousesByFilter(target: any) {
    const model = target === 'newRegister' ? this.newRegisterFilterWarehouse : target.filterWarehouse;
  
    model.class = 'loading';
    this.warehouseService.getWarehouseByClue(model.value).subscribe({
      next: (response: ResponseObject) => {
        this.allWarehouses = response.data as WarehouseResponse[];
        const filtered = this.allWarehouses.filter(w => this.allowedWarehouses[w.id]) || [];
  
        if (target === 'newRegister') {
          this.newRegisterWarehouses = filtered.length ? filtered : this.allWarehouses;
          this.newRegisterFilterWarehouse.class = 'fa-list';
        } else {
          target.warehouses = filtered.length ? filtered : this.allWarehouses;
          target.filterWarehouse.class = 'fa-list';
        }
      },
      error: (error: HttpErrorResponse) => {
        if (target === 'newRegister') {
          this.newRegisterFilterWarehouse.class = 'fa-xmark';
        } else {
          target.filterWarehouse.class = 'fa-xmark';
        }
        this.toastService.error(error.error.message);
      }
    });
  }
  
  

  getDepreciationsForCategory(categoryId: number): any[] {
    const category = this.depreciations.find(dep => dep.id === categoryId);
    return category ? category.depreciations : [];
  }
  
  onCategoryChange(ppeitem: any): void {
    const category = this.depreciations.find(dep => dep.id === ppeitem.selectedCategoryId);
    if (category) {
      // Asignamos el porcentaje de la categoría seleccionada
      ppeitem.percentage = category.percentage;
  
      // Por defecto seleccionamos el primer tipo de depreciación de la categoría
      if (category.depreciations.length > 0) {
        ppeitem.depreciation = category.depreciations[0].id;
      } else {
        ppeitem.depreciation = null;
      }
    } else {
      ppeitem.percentage = null;
      ppeitem.depreciation = null;
    }
  }

  onDepreciationChange(ppeitem: any): void {
    const category = this.depreciations.find(dep => dep.id === ppeitem.selectedCategoryId);
    if (category) {
      // Simplemente actualizamos el porcentaje basado en la categoría seleccionada
      ppeitem.percentage = category.percentage;
    }
  }
  

  savePpeItem(item){
    this.ppeService.updateTempDepreciation(item.id, item).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Actualizado correctamente");
        this.getInitData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  saveAllItems() {
    if (this.totalCumulative !== this.document.total) {
      this.toastService.error("El total acumulado no es igual al total del documento");
      return;
    }
  
    // 1. Guardar copia de los costos originales
    const originalCosts = this.pagination.filter.map(item => ({
      id: item.id,
      originalCost: item.cost
    }));
  
    // 2. Guardar copia del documento original para rollback (si quieres también)
    const originalDocumentTotal = this.document.total;
    const originalDocumentDeclaredTotal = this.document.declaredTotal;
  
    // 3. Primero editar el documento
    // const totalDoc = parseFloat((this.document.total / 1.12).toFixed(2));
    // const totalDec = parseFloat((this.document.declaredTotal / 1.12).toFixed(2));
    const totalDoc = this.document.total
    const totalDec = this.document.declaredTotal
    const request = {
      id: this.document.id,
      user: this.authService.getUser().id,
      company: Number(this.authService.getCurrentCompanyId()),
      vendor: this.clientSelected?.id || null,
      vendorName: this.clientSelected?.name || '',
      category: 4,
      categoryName: '',
      expType: 4,
      tdec: totalDec,
      tdoc: totalDoc,
      docDate: new Date(this.document.date).toISOString(),
      inputDate: new Date(this.document.date).toISOString(),
      creationDate: Date.now(),
      sDoc: this.document.series,
      noDoc: this.document.number,
      desc: this.document.description,
      service: "false",
      currency: 0,
      location: null,
      type: this.document.typeId
    };
  
    this.expenseService.updateTempExpense(this.document.id, request).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          // Actualizar documento visualmente
          const temp = response.data;
          this.document = {
            id: temp.id || 0,
            date: this.convertTimestampToDate(temp.docDate),
            month: this.convertTimestampToMonth(temp.inputDate),
            typeId: temp.type || null,
            expenseType: 'Producto',
            series: temp.sDoc || '',
            number: temp.noDoc || '',
            total: temp.tdoc || 0,
            declaredTotal: temp.tdec || 0,
            description: temp.desc || ''
          };
  
          // 4. Ahora modificar los items
          const requests = this.pagination.filter.map(item => {
            //item.cost = parseFloat((item.cost / 1.12).toFixed(2));
            // item.cost = parseFloat((item.cost / 1.12).toFixed(2));
            return this.ppeService.updateTempDepreciation(item.id, item);
          });
  
          forkJoin(requests).subscribe({
            next: (responses: ResponseObject[]) => {
              // 5. Finalmente guardar todos los items
              this.ppeService.saveTempsDepreciation().subscribe({
                next: (response: ResponseObject) => {
                  this.toastService.success("Guardados correctamente");
                  this.globalState.setIsTranslate(false);
                  this.isTranslate = false;
                  this.cleanDocument();
                  this.getInitData();
                },
                error: (error: HttpErrorResponse) => {
                  this.toastService.error("Error al guardar: " + error.error.message);
                  //this.rollbackItems(originalCosts);
                  //this.rollbackDocument(originalDocumentTotal, originalDocumentDeclaredTotal);
                  this.cleanDocument();
                  this.getInitData();
                }
              });
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.error("Error al actualizar los items: " + error.error.message);
              //this.rollbackDocument(originalDocumentTotal, originalDocumentDeclaredTotal);
              this.cleanDocument();
              this.getInitData();
            }
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al editar el documento: " + error.error.message);
      }
    });
  }
  
  rollbackItems(originalCosts: { id: number, originalCost: number }[]) {
    const rollbackRequests = this.pagination.filter.map(item => {
      const original = originalCosts.find(o => o.id === item.id);
      if (original) {
        item.cost = original.originalCost;
      }
      return this.ppeService.updateTempDepreciation(item.id, item);
    });
  
    forkJoin(rollbackRequests).subscribe({
      next: () => {
        this.toastService.info("Se revirtieron los cambios de los items correctamente.");
      },
      error: (rollbackError: HttpErrorResponse) => {
        this.toastService.error("Error al revertir los cambios de los items: " + rollbackError.error.message);
      }
    });
  }
  
  rollbackDocument(originalTotal: number, originalDeclaredTotal: number) {
    const rollbackRequest = {
      id: this.document.id,
      user: this.authService.getUser().id,
      company: Number(this.authService.getCurrentCompanyId()),
      vendor: this.clientSelected?.id || null,
      vendorName: this.clientSelected?.name || '',
      category: 4,
      categoryName: '',
      expType: 4,
      tdec: originalDeclaredTotal,
      tdoc: originalTotal,
      docDate: new Date(this.document.date).toISOString(),
      inputDate: new Date(this.document.date).toISOString(),
      creationDate: Date.now(),
      sDoc: this.document.series,
      noDoc: this.document.number,
      desc: this.document.description,
      service: "false",
      currency: 0,
      location: null,
      type: this.document.typeId
    };
  
    this.expenseService.updateTempExpense(this.document.id, rollbackRequest).subscribe({
      next: () => {
        this.toastService.info("Se revirtió el total del documento correctamente.");
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al revertir el documento: " + error.error.message);
      }
    });
  }
  
  

  selectClient(client: any, status) {
    this.client.value = "";
    this.client.class = "";
    this.client.required = false;
    this.filterClients = this.clients;
    console.log(client);
    this.clientSelected = client;
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";
    this.timeout = setTimeout(() => {
      this.client.class = "loading";
      this.vendorService.getProvidesByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data;
          if (this.client.filterElements.length == 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        }, error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener los datos del proveedor " + this.client.value);
        }
      })
    }, 500);
  }

  addDocument() {
    if(this.document.id == 0){
      console.log("Agregar Documento");
      const request = {
        vendor: this.clientSelected?.id || null,
        vendorName: this.clientSelected?.name || '',
        category: -1,
        categoryName: '',
        expType: 4,
        tdec: this.document.declaredTotal,
        tdoc: this.document.total,
        docDate: new Date(this.document.date).toISOString(),
        inputDate: new Date(this.document.date).toISOString(),
        sDoc: this.document.series,
        noDoc: this.document.number,
        desc: this.document.description,
        service: "false",
        type: this.document.typeId.toString()
      };
      this.expenseService.setTempPPE(request).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Documento agregado correctamente");
          this.getPPETempDoc();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
    }else{
      console.log("Editar Documento");
      console.log(this.clientSelected)
      
      const request = {
        id: this.document.id,
        user: this.authService.getUser().id, // suponiendo que lo obtienes del authService
        company: Number(this.authService.getCurrentCompanyId()), // si tienes un método así
        vendor: this.clientSelected?.id || null,
        vendorName: this.clientSelected?.name || '',
        category: 4,
        categoryName: '',
        expType: 4,
        tdec: this.document.declaredTotal,
        tdoc: this.document.total,
        docDate: new Date(this.document.date).toISOString(),
        inputDate: new Date(this.document.date).toISOString(),
        creationDate: Date.now(), // o mantenlo si tienes el original
        sDoc: this.document.series,
        noDoc: this.document.number,
        desc: this.document.description,
        service: "false",
        currency: 0,
        location: null,
        type: this.document.typeId
      };
      

      this.expenseService.updateTempExpense(this.document.id,request).subscribe({
        next: (response: ResponseObject) => {
          console.log(response.data)
          if(response.data){
            const temp = response.data;

            console.log("Retorno el temp");
            console.log(temp);

            // Buscar el proveedor en la lista de clients
            const clientFromList = this.clients.find(c => c.id == temp.vendor?.toString());

            if (clientFromList) {
              this.selectClient(clientFromList, 1);
            }else{
              // Error no encuentra el proveedor que seleccione otro 
            }
    
            // Asignar documento
            this.document = {
              id: temp.id || 0,
              date: this.convertTimestampToDate(temp.docDate),
              month: this.convertTimestampToMonth(temp.inputDate),
              typeId: temp.type || null,
              expenseType: 'Producto',
              series: temp.sDoc || '',
              number: temp.noDoc || '',
              total: temp.tdoc || 0,
              declaredTotal: temp.tdec || 0,
              description: temp.desc || ''
            };
            this.toastService.success("Documento editado correctamente");
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
    }
  }

  setFormEquipment(detail: ExpenseDocTempDetailResponse) {
    this.newRegister.name = detail.description;
    this.newRegister.quantity = detail.quantity;
    this.newRegister.cost = detail.price;
  }

  addPpeRegister() {
    this.newRegister.depreciation = this.newRegisterDepreciationId.toString();
    this.newRegister.percentage = this.newRegisterPercentage;
  
    this.ppeService.createTempDepreciation(this.newRegister).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Agregado correctamente");
        this.getDepreciations();
        this.cleanNewRegister();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
  

  onNewRegisterCategoryChange(): void {
    const category = this.depreciations.find(dep => dep.id === this.newRegisterCategoryId);
    if (category) {
      this.newRegisterPercentage = category.percentage;
      this.newRegisterDepreciationId = category.depreciations.length > 0 ? category.depreciations[0].id : null;
    } else {
      this.newRegisterPercentage = 0;
      this.newRegisterDepreciationId = null;
    }
  }
  
  cleanNewRegister() {
    this.newRegister = {
      code: '',
      name: '',
      cost: 0,
      percentage: 0,
      depreciation: '',
      asignedName: '',
      asignedDPI: 0,
      localizationName: '',
      quantity: 0
    };
  
    // Reset de variables globales relacionadas
    this.newRegisterFilterWarehouse = new InputAutocompleteModel('', false, false, '', '', '', '', null, []);
    this.newRegisterWarehouses = [];
    this.newRegisterWarehouseSelected = null;
  
    this.newRegisterCategoryId = null;
    this.newRegisterDepreciationId = null;
    this.newRegisterPercentage = 0;
  }

  convertTimestampToDate(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-CA'); // devuelve 'yyyy-mm-dd'
  }
  
  convertTimestampToMonth(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${year}-${month}`; // devuelve 'yyyy-mm'
  }

  cleanDocument() {
    this.document = {
      id: 0,
      date: '',
      month: '',
      typeId: null,
      expenseType: 'Producto',
      series: '',
      number: '',
      total: 0,
      declaredTotal: 0,
      description: ''
    };
  }
  
  deleteActualDocument(){
    this.expenseService.deleteTempPPE().subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Documento actual eliminado correctamente");
        this.cleanDocument();
        this.getInitData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  deletePPEItem(ppeItem){
    this.ppeService.deletePpeItem(ppeItem.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Equipo eliminado con exito");
        this.getDepreciations();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }
  
  

}
